<app-retailer-top-bar [showBackArrow]="true"
                      [showNotificationBell]="true"
                      [unreadNotificationCount]="unreadNotificationCount"
                      [previousPage]="'/retailer'"
                      (onBack)="turnLightsOff()"
                      (onNotificationBell)="toggleNotificationWindow(true)"
                      (onNewStudio)="onNewStudio()">
    >
</app-retailer-top-bar>
<!-- Notification Window Overlay -->
@if (showNotificationWindow) {
    <div
            class="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center z-50 pt-10">
    <div
            class="rounded-lg shadow-lg p-6 relative w-[90%] max-w-md max-h-[80vh] flex flex-col text-white"
            style="background-color: #1a1a1a;"
    >
        <!-- Close Button -->
        <button
                class="absolute top-4 right-4 p-2 rounded hover:bg-gray-700 transition-colors"
                (click)="toggleNotificationWindow(false)"
                aria-label="Close"
        >
            <img src="/assets/images/close.svg" alt="Close" class="h-6 w-6 invert" height="24" width="24"/>
        </button>
        <!-- Header -->
        <h2 class="text-2xl mb-4 font-serif">News</h2>
        <!-- Loading Spinner -->
        @if (loadingNotifications) {
            <div class="flex justify-center py-10 flex-grow">
                <div class="w-8 h-8 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
        }
        <!-- No Notifications Placeholder -->
        @if (!loadingNotifications && displayedNotifications.length === 0) {
            <div class="flex-grow">
                <div class="text-center text-gray-400 py-10">
                    No unread notifications available.
                </div>
        </div>
        }
        <!-- Scrollable notification list -->
        @if (!loadingNotifications && displayedNotifications.length > 0) {
        <div
                class="overflow-auto flex-grow space-y-4 pr-1"
        >
            @for (notif of displayedNotifications; track notif) {
            <div
                    class="border-t border-gray-600 first:border-t-0 pt-4 flex items-start gap-3"
            >
                <!-- Status dot -->
                <div class="mt-1 w-4 h-4 flex items-center justify-center">
                    @if (!notif.read) {
                        <span class="relative flex size-3">
                    <span
                      class="absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"
                      [ngStyle]="{ 'background-color': '#1998FC' }"
                    ></span>
                    <span
                      class="relative inline-flex size-3 rounded-full"
                      [ngStyle]="{ 'background-color': '#1998FC' }"
                    ></span>
                  </span>
                    } @else {
                        <span
                    class="inline-flex size-3 rounded-full"
                    [ngStyle]="{ 'background-color': '#D3D3D3' }"
                        ></span>
                    }
                </div>
                <!-- Image and content -->
                <div class="flex flex-col flex-grow gap-2">
                    <p class="font-semibold">{{ notif.title }}</p>
                    <div class="flex gap-3">
                        @if (notif.imageUrl) {
                            <img
                                    [src]="notif.imageUrl"
                                    alt="Notification image"
                                    class="w-14 h-14 object-cover rounded"/>
                        }
                        @if (!notif.imageUrl) {
                            <img
                                    alt="Notification placeholder"
                                    class="w-14 h-14 object-cover rounded"
                                    src="/assets/images/no-image.png"/>
                        }
                        <div class="flex flex-col flex-grow">
                            <p class="text-sm text-gray-300 line-clamp-2">{{ notif.message }}</p>
                        </div>
                        @if (!notif.read) {
                            <button
                                    (click)="markNotificationAsRead(notif.id)"
                                    class="bg-blue-500 hover:bg-blue-600 text-white text-xs rounded px-4 py-2 whitespace-nowrap">
                                Mark as read
                            </button>
                        }
                    </div>
                </div>
            </div>
            }
        </div>
        }
        <!-- Bottom button group -->
        <div class="mt-4 flex justify-center gap-3">
            @if (!showAllNotifications) {
                <button
                        (click)="showAllNotifications = true"
                        class="border border-white text-white rounded px-4 py-2 hover:bg-gray-700">
                    Show all
                </button>
            }
            @if (unreadNotificationCount > 0) {
                <button
                        (click)="markAllNotificationsAsRead()"
                        class="border border-white text-white rounded px-4 py-2 hover:bg-gray-700">
                    Mark all as read
                </button>
            }
        </div>
    </div>
    </div>
}


<div class="w-full relative">
    <img src="/assets/images/select-vehicle-model-header.png" alt="Select Vehicle Model" class="w-full">
    <h1
            class="text-white font-light text-4xl absolute text-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
    >
        Samples
    </h1>
</div>
<div class="flex gap-10 items-end my-4 ">
    <div class="input-container">
        <!-- SVG Icon -->
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M11.941 0C10.4768 0.00137155 9.04073 0.40138 7.78672 1.1571C6.53271 1.91283 5.50814 2.99574 4.82295 4.28964C4.13776 5.58354 3.81782 7.03959 3.89745 8.50154C3.97709 9.9635 4.45329 11.3762 5.27497 12.588L0.143966 17.719C0.0506379 17.8136 -0.0013522 17.9414 -0.000602352 18.0743C0.000147495 18.2072 0.053576 18.3344 0.147966 18.428L1.56997 19.856C1.66797 19.947 1.79597 20.001 1.92897 20.001C2.06197 20.001 2.19097 19.946 2.28597 19.853L2.28297 19.856L7.41197 14.725C8.62335 15.5479 10.036 16.0252 11.4983 16.1056C12.9605 16.1861 14.417 15.8666 15.7114 15.1815C17.0057 14.4965 18.0889 13.4717 18.8447 12.2174C19.6005 10.963 20.0002 9.52644 20.001 8.062C20.0002 5.92433 19.1506 3.87445 17.6391 2.36289C16.1275 0.851332 14.0776 0.00179504 11.94 0.000999928L11.941 0ZM11.941 1.51C15.557 1.511 18.49 4.444 18.49 8.061C18.49 11.678 15.557 14.606 11.94 14.606C8.32297 14.606 5.39397 11.674 5.39397 8.061C5.39582 6.32527 6.08581 4.66108 7.31269 3.43326C8.53958 2.20544 10.2032 1.51418 11.939 1.511"
                  fill="#E8E8E8"/>
        </svg>

        <!-- Input Field -->
        <input type="text" placeholder="Search" (input)="onFilterChange()" [(ngModel)]="search"
               autocomplete="off"/>
    </div>
    <!-- Model Select Container -->
    <div class="tabs-container flex-grow">
        <div class="flex items-end">
            <!-- Tabs -->
            @for (tab of tabs; track tab; let i = $index) {
                <div
                        (click)="onTabChange(tab)"
                        [ngClass]="{ 'bg-gray-700 text-white selected-tab': this.selectedTab === tab, ' text-gray-800 dark:text-gray-300 unselected-tab': this.selectedTab !== tab }"
                        class="flex h-full items-center cursor-pointer px-4 py-2 transition-colors duration-300 ease-in-out"
                >
                    <p class="p-2 text-sm">{{ tab }}</p>
                </div>
            }
            <div class="flex-grow unselected-tab"></div>
        </div>
    </div>
</div>
<div class="relative">
    <!-- Filters Toggle and Floating Panel -->
    <div class="h-14 relative z-10">

        <div class="flex justify-between">
            <div class="flex items-center gap-2">
                <!-- Filters Button -->
                <div class="filter-container flex gap-2">
                    <div class="flex-1 relative flex justify-between items-center cursor-pointer p-2 rounded shadow-sm bg-[#1a1a1a]"
                         (click)="filtersExpanded = !filtersExpanded">

                        @if (filtersApplied) {
                            <span
                                    class="absolute -inset-y-0.5 -inset-x-1 block size-2.5 rounded-full bg-sky-500 z-10">
              </span>
                        }

                        <p class="text-lg">Filters</p>

                        @if (!filtersExpanded) {
                            <i class="pi pi-angle-right" style="font-size: 1.3rem"></i>
                        }
                        @if (filtersExpanded) {
                            <i class="pi pi-angle-up" style="font-size: 1.3rem"></i>
                        }
                    </div>

                    <button
                            pTooltip="Clear Filters"
                            tooltipPosition="top"
                            class="reset-btn cursor-pointer p-2 rounded shadow-sm flex items-center justify-center"
                            (click)="clearFilters()">
                        <i class="pi pi-filter-slash" style="font-size: 1rem"></i>
                    </button>

                </div>


                <!-- Floating Filter Panel -->
                @if (filtersExpanded) {
                    <div
                            class="absolute top-full left-0 mt-2 w-[300px] p-3  rounded shadow-xl z-20 filter-container bg-[#1a1a1a]">
                        <div class="grid grid-cols-1 gap-1">
                            <!-- Expiration Section -->
                            <div>
                                <div (click)="expirationFilterExpanded = !expirationFilterExpanded"
                                     class="flex items-center justify-between cursor-pointer mb-2">
                                    <p class="mb-0 text-lg">Expiration</p>
                                    @if (!expirationFilterExpanded) {
                                        <i class="pi pi-angle-right text-sm"></i>
                                    }
                                    @if (expirationFilterExpanded) {
                                        <i class="pi pi-angle-up text-sm"></i>
                                    }
                                </div>
                                @if (expirationFilterExpanded) {
                                    <div class="grid grid-cols-1 gap-3 ml-3 mb-3">
                                        @for (exp of expirationFilters; track exp) {
                                            <div class="flex items-center gap-2">
                                                <p-checkbox
                                                        (onChange)="onFilterChange()"
                                                        [(ngModel)]="exp.selected"
                                                        [binary]="true"
                                                        [inputId]="'exp-' + exp.id"
                                                        size="large"
                                                ></p-checkbox>
                                                <label [for]="'exp-' + exp.id">{{ exp.name }}</label>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            <!-- Types Section -->
                            <div>
                                <div (click)="sampleTypeFilterExpanded = !sampleTypeFilterExpanded"
                                     class="flex items-center justify-between cursor-pointer mb-2">
                                    <p class="mb-0 text-lg">Types</p>
                                    @if (!sampleTypeFilterExpanded) {
                                        <i class="pi pi-angle-right text-sm"></i>
                                    }
                                    @if (sampleTypeFilterExpanded) {
                                        <i class="pi pi-angle-up text-sm"></i>
                                    }
                                </div>
                                @if (sampleTypeFilterExpanded) {
                                    <div class="grid grid-cols-1 gap-3 ml-3 mb-3">
                                        @for (type of sampleTypeFilters; track type) {
                                            <div class="flex items-center gap-2">
                                                <p-checkbox
                                                        (onChange)="onFilterChange()"
                                                        [(ngModel)]="type.selected"
                                                        [binary]="true"
                                                        [inputId]="'type-' + type.id"
                                                        size="large"
                                                ></p-checkbox>
                                                <label [for]="'type-' + type.id">{{ type.name }}</label>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            <!-- Categories Section -->
                            <div>
                                <div (click)="sampleCategoryFilterExpanded = !sampleCategoryFilterExpanded"
                                     class="flex items-center justify-between cursor-pointer mb-2">
                                    <p class="mb-0 text-lg">Categories</p>
                                    @if (!sampleCategoryFilterExpanded) {
                                        <i class="pi pi-angle-right text-sm"></i>
                                    }
                                    @if (sampleCategoryFilterExpanded) {
                                        <i class="pi pi-angle-up text-sm"></i>
                                    }
                                </div>
                                @if (sampleCategoryFilterExpanded) {
                                    <div class="grid grid-cols-1 gap-3 ml-3 mb-3">
                                        @for (cat of sampleCategoryFilters; track cat) {
                                            <div class="flex items-center gap-2">
                                                <p-checkbox
                                                        (onChange)="onFilterChange()"
                                                        [(ngModel)]="cat.selected"
                                                        [binary]="true"
                                                        [inputId]="'cat-' + cat.id"
                                                        size="large"
                                                ></p-checkbox>
                                                <label [for]="'cat-' + cat.id">{{ cat.name }}</label>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            <!-- State Section -->
                            <div>
                                <div (click)="sampleStateFilterExpanded = !sampleStateFilterExpanded"
                                     class="flex items-center justify-between cursor-pointer mb-2">
                                    <p class="mb-0 text-lg">State</p>
                                    @if (!sampleStateFilterExpanded) {
                                        <i class="pi pi-angle-right text-sm"></i>
                                    }
                                    @if (sampleStateFilterExpanded) {
                                        <i class="pi pi-angle-up text-sm"></i>
                                    }
                                </div>
                                @if (sampleStateFilterExpanded) {
                                    <div class="grid grid-cols-1 gap-3 ml-3 mb-3">
                                        @for (state of sampleStateFilters; track state) {
                                            <div class="flex items-center gap-2">
                                                <p-checkbox
                                                        (onChange)="onFilterChange()"
                                                        [(ngModel)]="state.selected"
                                                        [binary]="true"
                                                        [inputId]="'state-' + state.id"
                                                        size="large">
                                                </p-checkbox>
                                                <label [for]="'state-' + state.id">{{ state.name }}</label>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            <!-- Battery State Section -->
                            <div>
                                <div (click)="batteryStateFilterExpanded = !batteryStateFilterExpanded"
                                     class="flex items-center justify-between cursor-pointer mb-2">
                                    <p class="mb-0 text-lg">Battery State</p>
                                    @if (!batteryStateFilterExpanded) {
                                        <i class="pi pi-angle-right text-sm"></i>
                                    }
                                    @if (batteryStateFilterExpanded) {
                                        <i class="pi pi-angle-up text-sm"></i>
                                    }
                                </div>
                                @if (batteryStateFilterExpanded) {
                                    <div class="grid grid-cols-1 gap-3 ml-3 mb-3">
                                        @for (battery of batteryStateFilters; track battery) {
                                            <div class="flex items-center gap-2">
                                                <p-checkbox
                                                        (onChange)="onFilterChange()"
                                                        [(ngModel)]="battery.selected"
                                                        [binary]="true"
                                                        [inputId]="'battery-' + battery.id"
                                                        size="large">
                                                </p-checkbox>
                                                <label [for]="'battery-' + battery.id">{{ battery.name }}</label>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            <!-- Drawer State Section -->
                            <div>
                                <div (click)="drawerStateFilterExpanded = !drawerStateFilterExpanded"
                                     class="flex items-center justify-between cursor-pointer mb-2">
                                    <p class="mb-0 text-lg">Drawer State</p>
                                    @if (!drawerStateFilterExpanded) {
                                        <i class="pi pi-angle-right text-sm"></i>
                                    }
                                    @if (drawerStateFilterExpanded) {
                                        <i class="pi pi-angle-up text-sm"></i>
                                    }
                                </div>
                                @if (drawerStateFilterExpanded) {
                                    <div class="grid grid-cols-1 gap-3 ml-3 mb-3">
                                        @for (drawer of drawerStateFilters; track drawer) {
                                            <div class="flex items-center gap-2">
                                                <p-checkbox
                                                        (onChange)="onFilterChange()"
                                                        [(ngModel)]="drawer.selected"
                                                        [binary]="true"
                                                        [inputId]="'drawer-' + drawer.id"
                                                        size="large">
                                                </p-checkbox>
                                                <label [for]="'drawer-' + drawer.id">{{ drawer.name }}</label>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
            <p-paginator
                    (onPageChange)="onPageChange($event)"
                    [first]="this.page * pageSize"
                    [rows]="pageSize"
                    [totalRecords]="totalRecords"
                    [showCurrentPageReport]="true"
                    [showPageLinks]="false"
                    [showJumpToPageDropdown]="false"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"/>
        </div>
    </div>

    <!-- Tabs Content -->
    <div class="flex gap-10 mt-5">
        <!-- My Samples -->
        @if (selectedTab === 'My Samples') {
            <div class="flex-grow">
                <div class="flex gap-4 flex-wrap">
                    @for (sample of samples; track sample) {
                        <div
                                (click)="onSelected(sample)"
                        [ngClass]="{
                            'selected-sample shimmer-once': isSelected(sample),
                            'hover:scale-[1.02] hover:shadow-md': !isSelected(sample)
                          }"
                                class="sample-box p-2 rounded cursor-pointer transition-all duration-300 ease-in-out"
                        >
                            <div class="flex flex-col justify-between h-full">
                                <div class="mb-5">
                                    @if (sample.sample?.media?.content?.cloudfrontUrl) {
                                        <img
                                                [src]="sample.sample?.media?.content?.cloudfrontUrl"
                                                alt="{{ sample.sample?.printedName }}"
                                                class="w-full h-32 object-cover rounded mb-2"/>
                                    }
                                    <p class="break-words">{{ sample.sample?.printedName }}</p>
                                    <p class="text-xs font-light-grey mb-1">
                                        {{ sample.sample?.detailNames }}
                                    </p>
                                </div>
                                <div>
                                    <div class="flex items-center mb-1 justify-between">
                                        <p class="text-xs font-light-grey">Battery:</p>
                                        <span class="flex items-center justify-between gap-1">
                      <img [src]="sample.getBatteryIconPath()" alt="battery" class="h-4 w-4"/>
                      <span class="text-xs">{{ sample.getChargingText() }}</span>
                    </span>
                                    </div>
                                    <p class="text-xs font-light-grey mb-1">
                                        Expiration: {{ sample.sample?.validTo ? transformDate(sample.sample?.validTo || '') : 'Never' }}
                                    </p>
                                    <p class="text-xs font-light-grey mb-1">
                                        Location: {{ sample.inDrawer ? 'In drawer' : 'Out of drawer' }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        }



        <!-- Sample Catalog -->
        @if (selectedTab === 'Sample Catalog') {
            <div class="flex-grow">
                <div class="flex gap-4 flex-wrap">
                    @for (sample of sampleCatalog; track sample) {
                        <div class="sample-box p-2 rounded text-wrap">
                            <div class="flex flex-col justify-between h-full">
                                <div class="mb-5">
                                    @if (sample?.media?.content?.cloudfrontUrl) {
                                        <img
                                                [src]="sample?.media?.content?.cloudfrontUrl"
                                                alt="{{ sample?.printedName }}"
                                                class="w-full h-32 object-cover rounded mb-2"/>
                                    }
                                    @if (!sample?.media?.content?.cloudfrontUrl) {
                                        <div class="w-full h-32 rounded mb-2 bg-gray-400 flex items-center justify-center"
                                        >
                                            <i class="pi pi-image text-white" style="font-size: 2rem;"></i>
                                        </div>
                                    }
                                    <p class="break-words">{{ sample?.printedName }}</p>
                                    <p class="text-xs font-light-grey mb-1">
                                        {{ sample.detailNames }}
                                    </p>
                                </div>
                                <div>
                                    <p class="text-xs font-light-grey mb-1">State: {{ sample.state | enumLabel }}</p>
                                    <p class="text-xs font-light-grey mb-1">
                                        Expiration: {{ sample?.validTo ? transformDate(sample?.validTo || '') : 'Never' }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
</div>

